export default __webpack_public_path__ + "static/media/img9.42134d90.png";